// extracted by mini-css-extract-plugin
export var button = "PlusLandingPageBase-module__button___gqZVr";
export var buttonContainer = "PlusLandingPageBase-module__buttonContainer___oGNJO";
export var cancel = "PlusLandingPageBase-module__cancel___jfaFy";
export var content = "PlusLandingPageBase-module__content___RVG0S";
export var copy = "PlusLandingPageBase-module__copy___PAwUJ";
export var desktopButton = "PlusLandingPageBase-module__desktopButton___sgplP";
export var head = "PlusLandingPageBase-module__head___xu_yj";
export var headline = "PlusLandingPageBase-module__headline___gaHod";
export var hero = "PlusLandingPageBase-module__hero___hjSRA";
export var lottie = "PlusLandingPageBase-module__lottie___xIcGR";
export var mobileButton = "PlusLandingPageBase-module__mobileButton___p355A";
export var picture = "PlusLandingPageBase-module__picture___NX6Lh";
export var subhead = "PlusLandingPageBase-module__subhead___Y1ynw";
export var texture = "PlusLandingPageBase-module__texture___h6Ji6";
export var title = "PlusLandingPageBase-module__title___O84sd";
export var wrapper = "PlusLandingPageBase-module__wrapper___v3toG";